module.exports = __webpack_public_path__ + "img/moon2.71bd17b0.svg";